import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useForm from 'components/FormUse';
import Loading from 'components/Loading';
import './style.scss';

const FormVerification = ({ externalSubmit = null, userEmail = '' }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [processOk, setProcessOk] = useState('');

    const {
        data,
        handleChange,
        handleSubmit,
        clearForm,
        errors
    } = useForm({
        validations: {
            digit1: {
                required: {
                    value: true,
                    message: "input-verification-required"
                }
            }, 
            digit2: {
                required: {
                    value: true,
                    message: "input-verification-required"
                }
            }, 
            digit3: {
                required: {
                    value: true,
                    message: "input-verification-required"
                }
            },
            digit4: {
                required: {
                    value: true,
                    message: "input-verification-required"
                }
            },
            digit5: {
                required: {
                    value: true,
                    message: "input-verification-required"
                }
            },
            digit6: {
                required: {
                    value: true,
                    message: "input-verification-required"
                }
            }
        },
        onSubmit: async (data) => {
            setIsLoading(true);
            let tokenData = '';
            for(const item in data){
                tokenData += data[item];
            }
            externalSubmit && externalSubmit(
                tokenData, 
                () => { setProcessOk('Ok'); }, 
                () => { 
                    setProcessOk('Error');
                    setIsLoading(false);
                    clearForm(() => {
                        document.getElementById(`textBoxDigit1`).focus();
                    });
                }
            );
        },
        initialValues: {
            digit1: '',
            digit2: '',
            digit3: '',
            digit4: '',
            digit5: '',
            digit6: ''
        }
    });

    useEffect(() => {
        let currentDigit = '';
        for(const dig in data){
            if(data[dig]!=='') currentDigit = dig;
        }
        switch(currentDigit){
            case 'digit1': document.getElementById(`textBoxDigit2`).focus(); break;
            case 'digit2': document.getElementById(`textBoxDigit3`).focus(); break;
            case 'digit3': document.getElementById(`textBoxDigit4`).focus(); break;
            case 'digit4': document.getElementById(`textBoxDigit5`).focus(); break;
            case 'digit5': document.getElementById(`textBoxDigit6`).focus(); break;
            case 'digit6': document.getElementById('submit').click(); break;
        }
    }, [data]);

    useEffect(() => {
        document.getElementById(`textBoxDigit1`).focus();
    }, []);

    return (
        <>
        <form onSubmit={handleSubmit}>
            <button style={{ display: 'none' }} type='submit' id="submit"></button>
            <p className="text-center">Ingresa el código de verificación que fue enviado a: <br /><br /><strong className="gray-dark">{userEmail}</strong></p>
            <div className="row">
                <div className="form-group w-100">
                    <div className="digits">
                        <input value={data.digit1 || ''} onChange={handleChange('digit1')} required maxLength="1" autoComplete="off" type="text" className={"form-control "+errors.digit1} name="textBoxDigit1" id="textBoxDigit1" />
                        <input value={data.digit2 || ''} onChange={handleChange('digit2')} required maxLength="1" autoComplete="off" type="text" className={"form-control "+errors.digit1} name="textBoxDigit2" id="textBoxDigit2" />
                        <input value={data.digit3 || ''} onChange={handleChange('digit3')} required maxLength="1" autoComplete="off" type="text" className={"form-control "+errors.digit1} name="textBoxDigit3" id="textBoxDigit3" />
                        <input value={data.digit4 || ''} onChange={handleChange('digit4')} required maxLength="1" autoComplete="off" type="text" className={"form-control "+errors.digit1} name="textBoxDigit4" id="textBoxDigit4" />
                        <input value={data.digit5 || ''} onChange={handleChange('digit5')} required maxLength="1" autoComplete="off" type="text" className={"form-control "+errors.digit1} name="textBoxDigit5" id="textBoxDigit5" />
                        <input value={data.digit6 || ''} onChange={handleChange('digit6')} required maxLength="1" autoComplete="off" type="text" className={"form-control "+errors.digit1} name="textBoxDigit6" id="textBoxDigit6" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <br />
                    {isLoading && <Loading type="metro" />}
                    {processOk!==''
                        &&
                        (processOk==='Ok'
                            ?
                            <p className="message-success">Token ingresado correctamente</p>
                            :
                            <p className="message-error">El token ingresado es incorrecto, verificar nuevamente en su correo.</p>
                        )
                    }
                </div>
            </div>
        </form>
        </>
    );
}

FormVerification.propTypes = {
    externalSubmit: PropTypes.func, 
    userEmail: PropTypes.string
};
export default FormVerification;